import { toast } from "react-toastify";
import store from "../../store";
import { setPaginationTotalCount } from "../../store/slices/commonSlice";
import {
  setDetailsData,
  setGetAllOrderDocument,
  setOrdersData,
  setPolicyData,
  setProductData,
} from "../../store/slices/orders/ordersSlice";
import api from "../../utils/interface";

export const getFilteredPspOrderList = async (name, status, page, size) => {
  const requestBody = {};
  if (
    typeof name === "string" &&
    name.trim() !== "" &&
    name !== "Select Product Name"
  ) {
    requestBody.name = name;
  }

  if (typeof name === "string" && status.trim() !== "" && status !== "all") {
    requestBody.status = status;
  }

  try {
    const response = await api.post(
      `/agsp/order/getFilteredPspOrderList?page=${page}&size=${size}`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    if (response && response.status === 200) {
      store.dispatch(setOrdersData(response.data.entity_list));
      store.dispatch(setPaginationTotalCount(response.data.total_count));
    }
  } catch (error) {
    console.error("Error fetching data", error);
  }
};

export const readData = (entityid, entitytype) => {
  let fd = new FormData();

  fd.append("entityid", entityid);
  fd.append("entitytype", entitytype);

  return api
    .post(`/entity/read`, fd, {})
    .then((res) => {
      store.dispatch(setDetailsData(res.data));
      store.dispatch(setPolicyData(res.data.Policy_detail));
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      throw err;
    });
};

export const getProductListing = async (order_id) => {
  try {
    const response = await api.get(
      `agsp/order/getProductDetails?order_id=${order_id}`,
    );
    store.dispatch(setProductData(response.data));

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const readPolicy = (entityid, entitytype) => {
  let fd = new FormData();

  fd.append("entityid", entityid);
  fd.append("entitytype", entitytype);
  api
    .post(`/entity/read`, fd, {})
    .then((res) => {
      //
      // store.dispatch(setPolicyData(res.data.Policy_detail));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const downloadDocumentFile = async (id, filename) => {
  try {
    const response = await api.get(`/media/downloadById/${id}`, {
      responseType: "arraybuffer",
    });

    const blob = new Blob([response.data], {
      type: "application/octet-stream",
    });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    toast.error(error.response?.data?.error_message || "Download failed");
  }
};

export const getAllOrderDocument = async (orderid) => {
  const fd = new FormData();

  fd.append("orderId", orderid);
  try {
    const response = await api.post("/agsp/order/getAllDocumentsForOrder", fd);
    if (response && response.status === 200) {
      store.dispatch(setGetAllOrderDocument(response.data));
      return response.data;
    }
  } catch (error) {
    console.log("Error getting Order documents", error);
  }
};
export const getOrdersData = async (filter) => {
  try {
    const { productId, status } = filter; // Destructure filter object

    const response = await api.get(`/agsp/order/getOrderDetailsForCustomer`, {
      params: {
        ...(productId && { productId }), // Include productId only if defined
        ...(status && { status }), // Include status only if defined
      },
    });

    // Dispatch the data to Redux store
    store.dispatch(setOrdersData(response.data));
  } catch (error) {
    console.error("Error fetching orders:", error);
  }
};

export const getChildAttributeValue = async (attributeId, parentValue) => {
  try {
    const response = await api.get(
      `/product/getChildAttributeValue?attributeId=${attributeId}&parentValue=${parentValue}`,
    );
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const checkCkycStatus = async (memberId, orderId) => {
  try {
    const response = await api.post(
      `/ckyc/member/status?member_id=${memberId}&order_id=${orderId}`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error checking CKYC status:", error);
    throw error;
  }
};

export const getCkycFlows = async () => {
  try {
    const response = await api.get(`/ckyc/flows`);
    return response.data;
  } catch (error) {
    console.error("Error fetching CKYC flows:", error);
    throw error;
  }
};

export const uploadCkycDocs = async (payload) => {
  try {
    const response = await api.post(
      `/ckyc/member/upload-doc`,
      payload,
      {
        timeout: 180000,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading CKYC docs:", error);
    throw error;
  }
};

export const verifyCkycId = async (payload) => {
  try {
    const response = await api.post(
      `/ckyc/member/verify`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error verifying CKYC ID:", error);
    throw error;
  }
};

